<template>
    <div class="agent-page">
        <!-- 页面头部 -->
        <div class="page-header">
            <div style="display: flex; flex-direction: column; text-align: start;">
                <h2 class="page-title">{{ projectInfo.projectType }}--招标项目编号：{{
                    projectInfo.projectNumber }}　招标项目名称：{{
                        projectInfo.projectName }}</h2>
                <h2 class="page-title" style="margin-top: 10px;">评标前准备</h2>
            </div>
            <el-button type="primary" icon="el-icon-arrow-left" @click="handleBack">返回项目流程界面</el-button>
        </div>
        
        <!-- 数据表格 -->
        <div class="table-section">
            <el-table :data="tableData" v-loading="loading" border style="width: 100%" class="data-table">
                <el-table-column prop="no" label="NO." width="60" align="center" />
                <el-table-column prop="reviewTime" label="评审时间" show-overflow-tooltip />
                <el-table-column label="包含标段" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <div v-for="(sectionName, index) in scope.row.includingSections" :key="index">
                            {{ sectionName }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="详细信息" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="handleMemberManagement(scope.row)"
                            class="action-btn">
                            专家验证
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <!-- 分页 -->
        <div class="pagination-section">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="pagination.currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pagination.pageSize"
                layout="total, sizes, prev, pager, next, jumper" :total="pagination.total" class="pagination" />
        </div>

        <!-- 成员管理弹窗 -->
        <el-dialog title="成员管理" :visible.sync="memberDialogVisible" width="85%" :before-close="handleCloseMemberDialog"
            :append-to-body="true" class="member-dialog">
       
            <!-- 成员列表表格 -->
            <el-table :data="memberList" border style="width: 100%" class="member-table">
                <el-table-column prop="index" label="#" width="60" align="center">
                    <template slot-scope="scope">
                        {{ scope.$index + 1 }}
                    </template>
                </el-table-column>
                <el-table-column prop="realName" label="专家姓名" show-overflow-tooltip />
                <el-table-column prop="idCard" label="身份证号" show-overflow-tooltip />
                <el-table-column prop="company" label="工作单位" show-overflow-tooltip />
                <el-table-column prop="phone" label="手机" show-overflow-tooltip />
                <el-table-column prop="identity" label="专家身份" show-overflow-tooltip>
                    <template slot-scope="scope">
                        {{ scope.row.identity == 0 ? '专家' : '甲方代表' }}
                    </template>
                </el-table-column>
                <el-table-column prop="professionalTitle" label="职称" show-overflow-tooltip />
                <!-- <el-table-column prop="region" label="地区" show-overflow-tooltip /> -->
                <el-table-column label="签章采集" width="100" align="center">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.collectStatus === true ? 'success' : 'info'" size="small">
                            {{ scope.row.collectStatus === true ? '已采集' : '未采集' }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="登录状态" width="100" align="center">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.loginStatus === true ? 'success' : 'danger'" size="small">
                            {{ scope.row.loginStatus === true ? '已登录' : '未登录' }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center" width="220">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="handleSendCode(scope.row)" class="action-btn"
                            :disabled="scope.row.countdown > 0">
                            {{ scope.row.countdown > 0 ? `${scope.row.countdown}s` : '发送验证码' }}
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
                 <!-- 提示信息区域 -->
            <div class="tips-container">
                <div class="tips-content">
                    <div class="tips-left">
                        <div class="tip-item">
                            <i class="el-icon-warning" style="color: #E6A23C; margin-right: 8px;"></i>
                            <span class="tip-text">扫码二维码关注公众号进行<strong>签章采集</strong></span>
                        </div>
                        <div class="tip-item">
                            <i class="el-icon-info" style="color: #409EFF; margin-right: 8px;"></i>
                            <span class="tip-text">专家开始评审前请先<strong>发送验证码</strong></span>
                        </div>
                    </div>
                    <div class="tips-right">
                        <div class="qrcode-wrapper">
                            <img src="../../../assets/image/new_slices/weixin.jpg" alt="公众号二维码" class="qrcode-image" />
                            <p class="qrcode-label">扫码关注公众号</p>
                        </div>
                    </div>
                </div>
            </div>

            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="memberDialogVisible = false">关闭</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {
    initBidEvaluationCommittee,
    getBidEvaluationCommitteeList,
    getBidEvaluationCommitteeExpertList,
    getBidEvaluationCommitteeExpertAuthorization
} from '@/api/bidEvaluationCommittee/api'
import { getProjectDetail } from '@/api/agent/api'
import { getProjectTypeName } from '@/utils/base'
export default {
    data() {
        return {
            // 评委会id
            bidEvaluationCommitteeId: '',
            // 项目信息
            projectInfo: {
                projectNumber: '',
                projectName: '',
                projectType: ''
            },
            projectCode: this.$route.query.projectCode,//项目编号
            projectId: this.$route.query.projectId,//项目id
            loading: false,//列表加载状态
            saving: false,//保存状态
            // 成员管理相关
            memberDialogVisible: false,
            memberFormDialogVisible: false,
            memberSaving: false,//成员保存状态
            memberFormTitle: '添加成员',
            tableData: [],//表单数据
            pagination: {
                currentPage: 1,//当前页
                pageSize: 10,//每页显示条数
                total: 0//总条数
            },
            // 成员列表数据
            memberList: [],
        }
    },
    computed: {
    },
    mounted() {
        this.loadData()
    },
    methods: {
        // 返回上一页
        handleBack() {
            this.$router.go(-1)
        },
        // 加载数据
        loadData() {
            this.initBidEvaluationCommittee()
            this.getProjectDetail()
        },
        // 获取项目详情
        getProjectDetail() {
            getProjectDetail({ projectCode: this.projectCode }).then(res => {
                if (res.code == 200) {
                    this.projectInfo.projectNumber = res.data.projectCode
                    this.projectInfo.projectName = res.data.projectName
                    this.projectInfo.projectType = getProjectTypeName(res.data.projectType)
                } else {
                    this.$message.error(res.msg || '获取项目详情失败')
                }
            }).catch(error => {
                console.error('获取项目详情失败:', error)
                this.$message.error('获取项目详情失败')
            })
        },
        //初始化页面数据接口
        initBidEvaluationCommittee() {
            this.loading = true
            initBidEvaluationCommittee(this.projectCode).then(res => {
                if (res.code === 200) {
                    this.loading = false
                    this.sectionOptions = res.data.bidSectionList
                    this.getBidEvaluationCommitteeList()
                } else {
                    this.loading = false
                    this.$message.error(res.msg || '获取数据失败')
                }
            })
        },
        // 评委会列表
        getBidEvaluationCommitteeList() {
            let params = {
                projectCode: this.projectCode,
                pageNum: this.pagination.currentPage,
                pageSize: this.pagination.pageSize
            }
            getBidEvaluationCommitteeList(params).then(res => {
                if (res.code === 200) {
                    this.pagination.currentPage = res.data.current
                    this.pagination.total = res.data.total
                    this.pagination.pageSize = res.data.size
                    this.tableData = (res.data.records || []).map((item, index) => {
                        return {
                            id: item.id,
                            no: (this.pagination.currentPage - 1) * this.pagination.pageSize + index + 1,
                            reviewTime: item.bidEvaluationStartTime,
                            includingSections: (item.bidSectionList || []).map(section => section.bidSectionName),
                            extractType: item.extractType,
                        }
                    })
                } else {
                    this.$message.error(res.msg || '获取数据失败')
                }
            })
        },

        // 成员管理
        handleMemberManagement(row) {
            this.memberDialogVisible = true
            this.bidEvaluationCommitteeId = row.id
            this.getBidEvaluationCommitteeExpertList();
        },

        // 获取评委会专家列表接口
        getBidEvaluationCommitteeExpertList() {
            getBidEvaluationCommitteeExpertList(this.bidEvaluationCommitteeId).then(res => {
                if (res.code === 200) {
                    this.memberList = res.data
                } else {
                    this.$message.error(res.msg || '获取数据失败');
                }
            })
        },
        // 关闭成员管理弹窗
        handleCloseMemberDialog() {
            this.memberDialogVisible = false
        },
        // 分页相关方法
        handleSizeChange(val) {
            this.pagination.pageSize = val
            this.loadData()
        },
        // 分页切换当前页码
        handleCurrentChange(val) {
            this.pagination.currentPage = val
            this.loadData()
        },
        // 发送登录验证码
        handleSendCode(row) {
            if (row.countdown > 0) return;
            this.$message.success('验证码已发送至 ' + row.phone);
            this.startCountdown(row);
        },
        // 开始倒计时
        startCountdown(row) {
            this.getBidEvaluationCommitteeExpertAuthorization(row)
                ;
        },
        // 专家预授权接口
        getBidEvaluationCommitteeExpertAuthorization(row) {
            getBidEvaluationCommitteeExpertAuthorization(row.idCard).then(res => {
                if (res.code === 200) {
                    this.$set(row, 'countdown', 60);
                    const timer = setInterval(() => {
                        if (row.countdown > 0) {
                            row.countdown--;
                        } else {
                            clearInterval(timer);
                        }
                    }, 1000)
                } else {
                    this.$message.error(res.msg || '获取数据失败');
                }
            })
        }
    },
}
</script>

<style lang="less" scoped>
@import '@/styles/minimal-gray-theme.less';

.agent-page {
    .apply-minimal-gray-theme();
}

.page-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-bottom: 20px;
    gap: 20px;

    .page-title {
        font-size: 16px;
        font-weight: 600;
        color: @gray-700;
        margin: 0;
        line-height: 1.5;
        position: relative;
        padding-left: 10px;

        &::before {
            content: '';
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            width: 3px;
            height: 16px;
            background: @gray-700;
            border-radius: 2px;
        }

        &:first-child::before {
            background: @primary-color;
        }
    }

    /deep/ .el-button {
        transition: all @transition-base ease;
        &:hover { transform: translateY(-1px); }
    }
}

.delete-btn {
    color: @error-color !important;
    &:hover { color: darken(@error-color, 10%) !important; }
}

// 提示信息区域样式
.tips-container {
    background: linear-gradient(135deg, #f5f7fa 0%, #e8eef5 100%);
    border-radius: 8px;
    padding: 20px;
    margin-bottom: 20px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.tips-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 30px;
}

.tips-left {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 15px;
}

.tip-item {
    display: flex;
    align-items: center;
    background: #fff;
    padding: 12px 16px;
    border-radius: 6px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
    transition: all 0.3s ease;

    &:hover {
        transform: translateX(5px);
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    }

    i {
        font-size: 18px;
    }

    .tip-text {
        font-size: 14px;
        color: #606266;
        line-height: 1.5;

        strong {
            color: #409EFF;
            font-weight: 600;
        }
    }
}

.tips-right {
    display: flex;
    align-items: center;
    justify-content: center;
}

.qrcode-wrapper {
    text-align: center;
    background: #fff;
    padding: 15px;
    border-radius: 8px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
    transition: all 0.3s ease;

    &:hover {
        transform: translateY(-3px);
        box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
    }

    .qrcode-image {
        width: 140px;
        height: 140px;
        border-radius: 6px;
        display: block;
        margin: 0 auto;
    }

    .qrcode-label {
        margin-top: 10px;
        font-size: 13px;
        color: #606266;
        font-weight: 500;
    }
}
</style>
